var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#26BDE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42272 3.3999C5.2983 3.3999 5.1767 3.50914 5.20376 3.6737L6.73611 12.9914C6.75594 13.112 6.83245 13.2241 6.95506 13.2241H8.81566L8.95272 14.7428H8.15914L10.0403 16.6245L11.9215 14.7428H11.1279L11.2649 13.2241H13.1255C13.2482 13.2241 13.3247 13.112 13.3445 12.9914L14.8768 3.6737C14.9039 3.50914 14.7823 3.3999 14.6579 3.3999H5.42272ZM5.70575 3.86423H14.3749L14.1189 5.42101C13.1141 5.3047 11.6075 6.59194 9.91489 5.74141C7.83158 4.69458 7.78645 5.82304 6.01208 5.7277L5.70575 3.86423ZM10.0334 7.12171C10.8514 8.53858 11.5497 9.08434 11.5497 10.043C11.5497 10.6838 11.1453 11.5138 10.0334 11.5138C8.92156 11.5138 8.51721 10.6838 8.51721 10.043C8.51721 9.08434 9.21548 8.53858 10.0334 7.12171Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.47c805116575da12fc5d3f732d51bf8a.svg";
export { ForwardRef as ReactComponent };